export default (state, getters, rootState) => val => {
    let form = state.form,
        a = false;
    switch (val) {
        case 1:
            a = form.OnlyOverdue;
            break;
        case 2:
            form.PayStates.forEach(i => {
                if (i === 0) a = true;
            });
            if (a) form.PayStates.forEach(i => {
                if (i === 1) a = true;
            });
            if (a) a = form.PayStates.length === 2;
            break;
        case 3:
            form.PayStates.forEach(i => {
                if (i === 2) a = true;
            });
            if (a) a = form.PayStates.length === 1;
            break;
        case 4:
            form.PayStates.forEach(i => {
                if (i === 3) a = true;
            });
            if (a) a = form.PayStates.length === 1;
            break;
        case 5:
            a = form.PayStates.length === 4;
            break;
        case 6:
            if (form.ManagerList.length > 1) break;
            a = form.ManagerList[0] === rootState.user.id;
            break;
    }
    return a ? 'primary' : 'info';
}